import {Integer, ThemeColorTextPath} from 'platform/foundation';

import {not} from 'ramda';

import {suffixTestId, TestIdProps} from 'shared/web';

import {useCatalogue} from '../../../hooks/useCatalogue';
import {ListText} from './ListText';

interface FeatureListColumnProps extends TestIdProps {
  spacing: Integer;
  textColor: ThemeColorTextPath;
  values?: string[] | null;
  isMyVehicle?: boolean;
  isMyAd?: boolean;
  compareWith?: string[] | null;
  isFirstWhite?: boolean;
  isBold?: boolean;
}

export function FeatureListColumn(props: FeatureListColumnProps) {
  const {getFeatureLabel} = useCatalogue();

  const colorOffset = props.isFirstWhite ? 1 : 0;

  const isMissing = (value: string) => {
    if (!props.compareWith) {
      return false;
    }

    return !props.compareWith.includes(value);
  };

  return props.values?.map((feature, index) => (
    <ListText
      // Unfortunatelly, we do not have an unique key
      // eslint-disable-next-line react/no-array-index-key
      key={`${feature}-${index}`}
      value={getFeatureLabel(feature)}
      textColor={props.textColor}
      showBackground={not((index + colorOffset) % 2)}
      showDot={index + 1 < (props.values?.length ?? 0)}
      isMyVehicle={props.isMyVehicle}
      isMyAd={props.isMyAd}
      isMissing={isMissing(feature)}
      isBold={props.isBold}
      data-testid={suffixTestId(`value[${index}]`, props)}
    />
  ));
}
